import React from "react";

import { IBand } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IFormButtons, IAPIError } from "shared/types";
import { fields, defaultValues as standardDefaultValues } from "./formData";

interface BandFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  apiError?: IAPIError | null;
  handleSubmit: (band: IBand) => void;
  handleClose: () => void;
}

export const BandForm: React.FC<BandFormProps> = ({
  buttons,
  handleSubmit,
  handleClose,
  hasError,
  defaultValues = standardDefaultValues,
  ...rest
}) => {
  return (
    <FormBuilder
      fields={fields}
      onSubmit={(band: IBand) => handleSubmit(band)}
      defaultValues={defaultValues}
      globalError
      submitMode="isDirty"
      apiErrorMessage={hasError}
      buttons={buttons}
      {...rest}
    />
  );
};
